import React from "react";
import Types from "prop-types";
import PhoneLoginForm from "./components/PhoneLoginForm";
import {
  loginWithEmail,
  loginWithMerchantEmail,
  loginWithPhone,
  loginWithInstantCredentials,
} from "../gateway/LoginGateway";
import OtpView from "../otp/OtpView";
import PasswordLoginForm from "./components/PasswordLoginForm";
import RedirectToLogin, {
  CSRF_QUERY_PARAM,
  CSRF_SESSION_STORAGE_FIELD,
  RedirectToLoginEnhanced,
} from "../common/RedirectToLogin";
import queryString from "query-string";
import { Redirect } from "react-router-dom";
import NameConfirmationLoginForm from "./components/NameConfirmationLoginForm";
import { parsePhone, sanitizePhone } from "../common/PhoneNumber";
import i18n from "i18next";
import { Trans } from "react-i18next";
import EmailLoginForm from "./components/EmailLoginForm";
import AppleLoginForm from "./components/AppleLoginForm";
import GoogleLoginForm from "./components/GoogleLoginForm";
import { ARGUS_APM } from "../../apm";
import { initProfiling } from "../device";
import Galileo, { GalileoContext } from "../../galileo";
import { getErrorIdFromErrorCode } from "../../utils/errorMapping";
import Analytika from "../../analytika";
import { parseAcrValues } from "../../utils/helpers";
import {
  ANALYTICKA_EVENT_NO_INVOICE_ID,
  ANALYTIKA_EVENTS,
} from "../../utils/constants";
import BlockedUser from "../blockedUser/BlockedUser";
import eventAnalytics from "../../analytikaV2";
import VerifyCardLoginForm from "./components/VerifyCardLoginForm";
import VerifyEmailLoginForm from "./components/VerifyEmailLoginForm";
import VerifyNameLoginForm from "./components/VerifyNameLoginForm";
import VerifyPinLoginForm from "./components/VerifyPinLoginForm";
import DashboardSelectionPage from "./components/DashboardSelectionPage";
import InstantCredentialsForm from "./components/InstantCredentialsForm";
import MerchantSignupForm from "./components/MerchantSignupForm";
import { fetchGuardToken } from "../Guard";
import { signupMerchant } from "../gateway/SignupGateway";

export const PHONE_LOGIN_FORM_VIEW = "phone_form";
export const EMAIL_LOGIN_FORM_VIEW = "email_form";
export const PASSWORD_FORM_VIEW = "password_form";
export const APPLE_LOGIN_FORM_VIEW = "apple_form";
export const GOOGLE_LOGIN_FORM_VIEW = "google_form";
export const OTP_VIEW = "otp";
export const NAME_CONFIRMATION = "name_confirmation";
export const REDIRECT_TO_IDP = "redirect_to_idp";
export const REDIRECT_TO_SIGNUP = "redirect_to_signup";
export const OTP_CHALLENGE = "otp";
export const PASSWORD_CHALLENGE = "password";
export const APPLE_CHALLENGE = "apple";
export const GOOGLE_CHALLENGE = "google";
export const CONFIRM_NAME_CHALLENGE = "confirm_name";
export const REDIRECT_TO_BLOCKED_USER = "redirect_to_blocked_user";
export const TRY_ANOTHER_WAY_CHALLENGE = "try_another_way";
export const card_challenge = "card";
export const name_challenge = "name";
export const email_challenge = "email";
export const pin_challenge = "pin";
export const VERIFY_CARD_FORM_VIEW = "verify__card_challenge";
export const VERIFY_EMAIL_FORM_VIEW = "verify_email_challenge";
export const VERIFY_FULL_NAME_FORM_VIEW = "verify_full_name_challenge";
export const VERIFY_PIN_FORM_VIEW = "verify_pin_challenge";
export const DASHBOARD_SELECTION_VIEW = "dashboard_selection";
export const INSTANT_CREDENTIALS_FORM_VIEW = "instant_credentials_form";
export const MERCHANT_SIGNUP_FORM_VIEW = "merchant_signup_form";

// Errors
const UNREGISTERED_USER = "unregistered_user";
const CHALLENGE_REQUIRED = "challenge_required";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      view: PHONE_LOGIN_FORM_VIEW,
      password: "",
      otp: "",
      device: "",
      recaptcha: "",
      redirectToIdpParams: {
        fieldName: null,
        value: null,
      },
      visibleFields: {
        appleButton: true,
        googleButton: true,
      },
      flowType: "phone",
      appleIdToken: null,
      googleIdToken: null,
      clientId: null,
      csrf: sessionStorage.getItem(CSRF_SESSION_STORAGE_FIELD),
      error: null,
      instantCredentialsUserId: "",
      emailOnly: false,
      merchantFullName: "",
      merchantSignupFlow: false,
      fallbackTo: null,
      signupAs: null,
      customerFallbackAttempted: false,
      invoiceId: null,
      phone: {
        countryCode: undefined,
        fullPhoneNumber: undefined,
        isValid: undefined,
        nationalPhoneNumber: undefined,
      },
      blockedErrorState: "",
      blockedErrorMsg: "",
      challenge: {
        fullname: "",
        CardPin: "",
        email: "",
        pin: "",
        password: "",
        current_priority: 1,
        available_challenges: null,
        masked_value: "",
        isTryAnotherWayVisible: false,
      },
    };
    this.processUrlParams();
    Galileo.fetchIsGoogleEnabledFlag();
  }

  static contextType = GalileoContext;

  deleteParamIfPresent(paramName, queryParams) {
    if (queryParams.has(paramName)) {
      queryParams.delete(paramName);
    }
  }

  async processUrlParams() {
    const { location, history } = this.props;
    var param = location.search;
    const {
      csrf,
      fullMobileNumber,
      clientId,
      showEmail,
      showApple,
      showGoogle,
      emailOnly,
      showInstantCredentials,
      view,
      acr_values: acrValues,
      fallbackTo,
      signupAs,
    } = queryString.parse(param);
    const externalParams = parseAcrValues(acrValues);

    if (csrf) {
      sessionStorage.setItem(CSRF_SESSION_STORAGE_FIELD, csrf);
      this.state.csrf = csrf;
    }
    this.state.clientId = clientId;
    this.state.invoiceId =
      externalParams?.invoice_id ?? ANALYTICKA_EVENT_NO_INVOICE_ID;
    this.state.emailOnly = emailOnly === "true";
    this.state.fallbackTo = fallbackTo === "customer" ? "customer" : null;
    this.state.signupAs =
      signupAs === "merchant" ? "merchant" : null;
    this.state.showEmail = showEmail === "true" || this.state.emailOnly;
    if (this.state.showEmail) {
      this.state.view = EMAIL_LOGIN_FORM_VIEW;
    }
    this.state.showInstantCredentials = showInstantCredentials === "true";
    if (this.state.showInstantCredentials) {
      this.state.view = INSTANT_CREDENTIALS_FORM_VIEW;
    }
    this.state.visibleFields.appleButton = showApple === "true";
    this.state.visibleFields.googleButton = showGoogle === "true";

    if (fullMobileNumber) {
      this.state.phone = parsePhone(fullMobileNumber);
    }
    if (view) {
      this.state.view = view;
    }

    if (clientId) {
      // Check if clientId is "not_defined" and show dashboard selection page
      if (clientId === "not_defined") {
        this.state.view = DASHBOARD_SELECTION_VIEW;
      }
    }
    const queryParams = new URLSearchParams(param);
    this.deleteParamIfPresent(CSRF_QUERY_PARAM, queryParams);
    history.replace({
      search: queryParams.toString(),
    });
  }

  onPhoneChange(phone) {
    this.setState({ phone });
  }
  onEmailChange(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      email: value,
      challenge: {
        ...prevState.challenge,
        email: value,
      },
    }));
  }
  onInstantCredentialsUserIdChange(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      instantCredentialsUserId: value,
      challenge: {
        ...prevState.challenge,
        instantCredentialsUserId: value,
      },
    }));
  }
  onCardPinChange(value) {
    this.setState((prevState) => ({
      challenge: {
        ...prevState.challenge,
        CardPin: value,
      },
    }));
  }
  onFullNameChange(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      challenge: {
        ...prevState.challenge,
        fullname: value,
      },
    }));
  }
  onPinChange(value) {
    this.setState((prevState) => ({
      challenge: {
        ...prevState.challenge,
        pin: value,
      },
    }));
  }
  onTryAnotherClickHandler() {
    let current_priority = this.state.challenge.current_priority;
    current_priority++;
    let nextChallenge = this.state.challenge.available_challenges
      .filter((c) => c.priority === current_priority)
      .at(0);
    if (!nextChallenge) {
      nextChallenge = this.state.challenge.available_challenges[0];
    }
    this.setState((prevState) => ({
      challenge: {
        ...prevState.challenge,
        current_priority: nextChallenge.priority,
        masked_value: nextChallenge.masked_value,
        fullname: "",
        CardPin: "",
        email: "",
        pin: "",
        password: "",
      },
      error: null,
      view: this.getChallengeView(nextChallenge.challenge_name),
    }));
  }
  onNameConfirmed(nameConfirmed) {
    if (nameConfirmed) {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
        button_name: "yes_its_me",
      });
      Analytika.fireEvent("Idtn_Web_NameConfirm_Approved", {
        phonenumber: this.state.phone?.fullPhoneNumber,
      });
    } else {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
        button_name: "no_iam_new_user",
      });
      Analytika.fireEvent("Idtn_Web_NameConfirm_Reject", {
        phonenumber: this.state.phone?.fullPhoneNumber,
      });
    }
    this.setState({ nameConfirmed: nameConfirmed });
  }

  onPasswordChange(event) {
    const value = event.target.value;
    if (value.length <= 1) {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_ENTER_PASSWORD, {
        dummy: "identity",
      });
    }
    this.setState({ password: event.target.value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.state.showInstantCredentials) {
      const instantUserId = this.state.instantCredentialsUserId?.trim();
      const password = this.state.password?.trim();
      if (!instantUserId) {
        this.setState({ submitting: false, error: "User ID is required" });
        return;
      }
      if (!password) {
        this.setState({ submitting: false, error: "Password is required" });
        return;
      }
    }
    this.setState({
      submitting: true,
      error: null,
    });
    const requestTypeAttr = event.target?.dataset?.requestType;
    if (requestTypeAttr) {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
        button_name: "continue",
      });
    }
    if (this.state.showEmail && this.state.customerFallbackAttempted) {
      this.login(
        this.loginCustomerEmailFallbackRequest.bind(this),
        "customer_email_fallback"
      );
    } else if (this.state.showEmail) {
      this.login(this.loginEmailRequest.bind(this), "email_login");
    } else if (this.state.showInstantCredentials) {
      this.login(
        this.loginInstantCredentialsRequest.bind(this),
        "instant_credentials"
      );
    } else {
      const requestType = event.target.dataset.requestType;
      if (requestType) {
        eventAnalytics.setPhoneNumber(this.state.phone?.fullPhoneNumber);
        eventAnalytics.setFlowName("phone");
        Analytika.fireEvent(requestType, {
          phonenumber: this.state.phone?.fullPhoneNumber,
        });
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.PYCK_TAP_CK_BUTTON, {
          flow: "identity",
          button_name: "continue",
          screen_name: "enter_phone",
        });
      }

      this.login(this.loginPhoneRequest.bind(this), requestType);
    }
  }

  onOtpVerify(otp) {
    if (this.state.merchantSignupFlow) {
      this.onMerchantOtpVerify(otp);
      return;
    }
    this.setState({ otp: otp, submitting: true });
    if (this.state.showEmail && this.state.customerFallbackAttempted) {
      this.login(
        this.loginCustomerEmailFallbackRequest.bind(this),
        "customer_email_fallback"
      );
    } else if (this.state.showEmail) {
      this.login(this.loginEmailRequest.bind(this), "email_login");
    } else {
      this.login(this.loginPhoneRequest.bind(this), "phone_otp_verify");
    }
  }

  onAppleTokenChanged(props) {
    let { proofToken, error } = props;
    this.setState(props);
    if (proofToken) this.redirectToIdp(proofToken);
    else if (error) {
      this.setState({ error });
    } else this.setState({ view: REDIRECT_TO_SIGNUP });
  }

  onGoogleTokenChanged(props) {
    let { proofToken, error } = props;
    this.setState(props);
    if (proofToken) this.redirectToIdp(proofToken);
    else if (error) {
      this.setState({ error });
    } else this.setState({ view: REDIRECT_TO_SIGNUP });
  }

  handleErrors(error, overrideMessage) {
    const errorMessage =
      overrideMessage ||
      error.response?.data?.message ||
      error.message ||
      "no response";
    this.setState({
      submitting: false,
      error: errorMessage,
    });

    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
      error_description: errorMessage,
      error_msg: error?.message || errorMessage || "Unknown error",
    });
  }

  handleUnknown400Errors(error) {
    var errorMessage = i18n.t("NO_RESPONSE");
    if (error?.additional_information?.error_code) {
      var errorCode =
        getErrorIdFromErrorCode(error?.additional_information?.error_code) ||
        error?.additional_information?.error_code;
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
        error_msg: errorMessage || "Unknown error",
        error_code_string: errorCode?.toString(),
      });
      if (errorCode === "USER_BLOCKED") {
        this.setState({
          view: REDIRECT_TO_BLOCKED_USER,
          blockedErrorState: error?.errorCode,
          blockedErrorMsg: error?.error_description,
        });

        errorMessage = (
          <Trans i18nKey="spring_security_error:USER_BLOCKED" t={this.props.t}>
            We cannot log you in at this time.
            <a href="https://help.careem.com/hc/en-us/requests/new?reason=account_issue">
              Please contact us for help.
            </a>
          </Trans>
        );
      } else {
        errorMessage = i18n.t("spring_security_error:" + errorCode);
      }
    } else if (error?.errorCode) {
      errorMessage = i18n.t("spring_security_error:" + error?.errorCode);
    } else if (error?.error_message) {
      errorMessage = error?.error_message;
    } else if (error?.errorMessage) {
      errorMessage = error?.errorMessage;
    }
    console.log(errorMessage);
    this.setState({
      submitting: false,
      error: errorMessage,
    });
  }

  handleChallengeErrors(additionalInformation) {
    switch (additionalInformation.challenge) {
      case OTP_CHALLENGE:
        this.setState({
          submitting: false,
          view: OTP_VIEW,
        });
        break;
      case APPLE_CHALLENGE:
        this.setState({
          submitting: false,
          view: APPLE_LOGIN_FORM_VIEW,
        });
        break;
      case GOOGLE_CHALLENGE:
        this.setState({
          submitting: false,
          view: GOOGLE_LOGIN_FORM_VIEW,
        });
        break;
      case PASSWORD_CHALLENGE:
        this.setState({
          submitting: false,
          view: PASSWORD_FORM_VIEW,
        });
        break;
      case CONFIRM_NAME_CHALLENGE:
        this.setState({
          submitting: false,
          view: NAME_CONFIRMATION,
          name: additionalInformation.name,
        });
        break;
      case TRY_ANOTHER_WAY_CHALLENGE:
        this.setState((prevState) => ({
          submitting: false,
          view: this.getChallengeView(
            additionalInformation.challenge_details[0].challenge_name
          ),
          challenge: {
            ...prevState.challenge,
            current_priority:
              additionalInformation.challenge_details[0].priority,
            masked_value:
              additionalInformation.challenge_details[0].masked_value,
            available_challenges: additionalInformation.challenge_details,
            isTryAnotherWayVisible:
              additionalInformation.challenge_details.length > 1,
          },
        }));
        break;
      default:
        break;
    }
  }
  getChallengeView(challenge_name) {
    switch (challenge_name) {
      case card_challenge:
        return VERIFY_CARD_FORM_VIEW;
      case name_challenge:
        return VERIFY_FULL_NAME_FORM_VIEW;
      case email_challenge:
        return VERIFY_EMAIL_FORM_VIEW;
      case pin_challenge:
        return VERIFY_PIN_FORM_VIEW;
      case PASSWORD_CHALLENGE:
        return PASSWORD_FORM_VIEW;
      default:
        break;
    }
  }
  login(loginRequest, requestType) {
    if (requestType) {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
        request_type: requestType,
      });
    }
    return loginRequest()
      .then((data) => {
        if (requestType) {
          eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
            request_type: requestType,
            request_status: "success",
          });
          Analytika.fireEvent(`${requestType}Success`, {
            phonenumber: this.state.phone?.fullPhoneNumber,
          });
        }
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SUCCESS_LOGIN, {
          destination_deeplink: "com.careem.identity",
        });
        // INFO: this will ensure to send all event that are in staged state
        eventAnalytics.flush().then(() => {
          this.redirectToIdp(data.token);
        });
      })
      .catch((error) => {
        const errorCode = error.response?.status;
        const error_description = error.response?.data?.error;
        const additional_challenge =
          error.response?.data?.additional_information?.challenge;
        if (requestType === "instant_credentials") {
          if (error.response?.status === 400) {
            this.handleUnknown400Errors(error.response.data);
          } else {
            this.handleErrors(error, "Authentication failed. Please try again.");
          }
          return;
        }
        if (requestType) {
          eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
            request_type: requestType,
            request_status: "failed",
            error_code_string: errorCode?.toString(),
            error_description: `${error_description}_${additional_challenge}`,
          });
          Analytika.fireEvent(`${requestType}Fail`, {
            phonenumber: this.state.phone?.fullPhoneNumber,
          });
        }
        if (ARGUS_APM) {
          ARGUS_APM.captureError(error);
        }
        if (error.response?.status === 400) {
          this.handle400Errors(error);
        } else {
          this.handleErrors(error);
        }
      });
  }

  async loginPhoneRequest() {
    if (!this.state.phone?.isValid) {
      const err = new Error("Please enter correct phone number.");
      throw err;
    }
    let profiling = await initProfiling().catch((ex) => {
      console.log(ex);
    });
    let payload = {
      phone_number: sanitizePhone(this.state.phone.fullPhoneNumber),
      profiling: profiling,
      otp: this.state.otp,
      name_confirmed: this.state.nameConfirmed,
      is_known_device: false,
      password: this.state.password,
    };
    if (this.state.challenge.pin) {
      payload["pin"] = this.state.challenge.pin;
    }
    if (this.state.challenge.email) {
      payload["email_verification"] = this.state.challenge.email;
    }
    if (this.state.challenge.CardPin) {
      payload["card_verification"] = this.state.challenge.CardPin;
    }
    if (this.state.challenge.fullname) {
      payload["full_name_verification"] = this.state.challenge.fullname;
    }

    return loginWithPhone(payload, this.state.clientId);
  }
  async loginEmailRequest() {
    let profiling = await initProfiling().catch((ex) => {
      console.log(ex);
    });
    const loginFn = this.state.emailOnly
      ? loginWithMerchantEmail
      : loginWithEmail;
    return loginFn(
      {
        email: this.state.email,
        otp: this.state.otp,
        profiling: profiling,
        password: this.state.password,
      },
      this.state.clientId
    );
  }

  async loginCustomerEmailFallbackRequest() {
    let profiling = await initProfiling().catch((ex) => {
      console.log(ex);
    });
    return loginWithEmail(
      {
        email: this.state.email,
        otp: this.state.otp,
        profiling: profiling,
        password: this.state.password,
      },
      this.state.clientId
    );
  }

  async loginInstantCredentialsRequest() {
    let guardAnswer = await fetchGuardToken("instant_credentials_login").catch(
      (ex) => {
        console.log(ex);
      }
    );
    const instantCredentialsClientId = this.state.clientId;
    const operatorId = this.state.instantCredentialsUserId?.trim();
    const password = this.state.password?.trim();
    return loginWithInstantCredentials(
      {
        operator_id: operatorId,
        password: password,
        guard_answer: guardAnswer,
      },
      instantCredentialsClientId
    );
  }

  onMerchantFullNameChange(event) {
    this.setState({ merchantFullName: event.target.value });
  }

  onMerchantSignupSubmit(event) {
    event.preventDefault();
    if (this.state.otp) {
      this.setState({
        submitting: true,
        error: null,
        merchantSignupFlow: true,
      });
      this.onMerchantOtpVerify(this.state.otp);
    } else {
      this.setState({
        submitting: true,
        error: null,
        merchantSignupFlow: true,
        view: OTP_VIEW,
      });
    }
  }

  onMerchantOtpVerify(otp) {
    this.setState({ otp: otp, submitting: true, error: null });
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
      request_type: "merchant_signup",
    });
    initProfiling()
      .catch((ex) => {
        console.log(ex);
      })
      .then((profiling) => {
        return signupMerchant({
          email: this.state.email,
          full_name: this.state.merchantFullName,
          password: this.state.password,
          otp: otp,
          onboard_experience_id: "STANDARD_MERCHANT_EMAIL",
          profiling: profiling,
          clientId: this.state.clientId,
        });
      })
      .then((data) => {
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
          request_type: "merchant_signup",
          request_status: "success",
        });
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SUCCESS_SIGNUP, {
          destination_deeplink: "com.careem.identity",
        });
        eventAnalytics.flush().then(() => {
          this.redirectToIdp(data.token);
        });
      })
      .catch((error) => {
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
          request_type: "merchant_signup",
          request_status: "failed",
          error_code_string: error.response?.status?.toString(),
          error_description: error.response?.data?.error,
        });
        if (ARGUS_APM) {
          ARGUS_APM.captureError(error);
        }
        if (error.response?.status === 400) {
          const errorData = error.response.data;
          if (
            errorData?.error === CHALLENGE_REQUIRED &&
            errorData?.additional_information?.challenge === OTP_CHALLENGE
          ) {
            this.setState({ submitting: false, view: OTP_VIEW });
          } else {
            this.handleUnknown400Errors(errorData);
            this.setState({ view: MERCHANT_SIGNUP_FORM_VIEW });
          }
        } else {
          this.handleErrors(error);
          this.setState({ view: MERCHANT_SIGNUP_FORM_VIEW });
        }
      });
  }

  handle400Errors(error) {
    switch (error.response.data?.error) {
      case UNREGISTERED_USER:
        if (
          this.state.emailOnly &&
          this.state.fallbackTo === "customer" &&
          !this.state.customerFallbackAttempted
        ) {
          this.setState({ customerFallbackAttempted: true }, () => {
            this.login(
              this.loginCustomerEmailFallbackRequest.bind(this),
              "customer_email_fallback"
            );
          });
        } else if (
          (this.state.emailOnly && !this.state.fallbackTo) ||
          this.state.signupAs === "merchant"
        ) {
          this.setState({
            submitting: false,
            view: MERCHANT_SIGNUP_FORM_VIEW,
          });
        } else {
          this.setState({
            submitting: false,
            view: REDIRECT_TO_SIGNUP,
          });
        }
        break;
      case CHALLENGE_REQUIRED:
        this.handleChallengeErrors(error.response.data?.additional_information);
        break;
      default:
        this.handleUnknown400Errors(error.response.data);
        break;
    }
  }

  redirectToIdp(proofToken) {
    this.setState({
      redirectToIdpParams: {
        fieldName: "proofToken",
        value: proofToken,
        clientId: this.state.clientId,
      },
      view: REDIRECT_TO_IDP,
    });
  }

  constructSignupEndpoint() {
    const {
      csrf,
      otp,
      phone,
      appleIdToken,
      googleIdToken,
      email,
      visibleFields,
      clientId,
    } = this.state;
    const fullMobileNumber = phone?.fullPhoneNumber;
    const searchQuery = new URLSearchParams();
    if (csrf) {
      searchQuery.append(CSRF_QUERY_PARAM, csrf);
    }
    if (otp && !email) {
      searchQuery.append("otp", otp);
    }
    if (phone?.isValid) {
      searchQuery.append("fullMobileNumber", fullMobileNumber);
    }
    if (email) {
      searchQuery.append("email", email);
    }
    if (visibleFields.appleButton) {
      searchQuery.append("showApple", visibleFields.appleButton);
    }
    if (visibleFields.googleButton) {
      searchQuery.append("showGoogle", visibleFields.googleButton);
    }
    if (appleIdToken) {
      searchQuery.append("appleIdToken", appleIdToken);
    }
    if (googleIdToken) {
      searchQuery.append("googleIdToken", googleIdToken);
    }
    if (clientId) {
      searchQuery.append("clientId", clientId);
    }
    if (this.state.fallbackTo) {
      searchQuery.append("fallbackTo", this.state.fallbackTo);
    }
    return `/signup?${searchQuery.toString()}`;
  }

  constructRecoveryEndpointEndpoint() {
    const {
      otp,
      phone,
      email,
      clientId,
      emailOnly,
      fallbackTo,
      showEmail,
    } = this.state;
    const fullMobileNumber = phone?.fullPhoneNumber;
    const searchQuery = new URLSearchParams();
    if (otp) {
      searchQuery.append("otp", otp);
    }
    if (clientId) {
      searchQuery.append("clientId", clientId);
    } else {
      searchQuery.append("clientId", "unknown");
    }
    if (emailOnly) {
      searchQuery.append("emailOnly", emailOnly);
    }
    if (email) {
      searchQuery.append("email", email);
    }
    const isMerchantRecovery =
      emailOnly &&
      fallbackTo === "customer" &&
      !this.state.customerFallbackAttempted;

    if (this.state.fallbackTo && !isMerchantRecovery) {
      searchQuery.append("fallbackTo", fallbackTo);
    }
    if (this.state.signupAs) {
      searchQuery.append("signupAs", this.state.signupAs);
    }
    if (fullMobileNumber) {
      searchQuery.append("phoneNumber", fullMobileNumber);
    }

    if (showEmail && !isMerchantRecovery) {
      return `/login?csrf=${this.state.csrf}&clientId=${clientId}&showApple=false&showGoogle=false`;
    }
    return `/session_init?${searchQuery.toString()}`;
  }

  createAccount() {
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_OPTION, {
      option_name: "create_account",
    });
    eventAnalytics.flush().then(() => {
      window.location.href = this.constructSignupEndpoint();
    });
  }
  componentDidMount() {
    Galileo.fetchIsGoogleEnabledFlag().then((toggle) =>
      this.setGoogleButtonVisibility(
        this.state.visibleFields.googleButton && toggle
      )
    );
  }

  setGoogleButtonVisibility(toggle) {
    this.setState({
      visibleFields: { ...this.state.visibleFields, googleButton: toggle },
    });
  }

  redirectToLoginHandler() {
    this.setState({
      view: PHONE_LOGIN_FORM_VIEW,
      error: null,
      phone: "",
      otp: "",
      customerFallbackAttempted: false,
    });
  }

  render() {
    const { error, submitting, view, visibleFields } = this.state;

    const { isEnhancedFormEnabled } = this.context;

    const renderMainContent = () => {
      switch (view) {
        case PHONE_LOGIN_FORM_VIEW:
          return (
            <PhoneLoginForm
              error={error}
              submitting={submitting}
              visibleFields={visibleFields}
              onPhoneChange={this.onPhoneChange.bind(this)}
              onAppleTokenChanged={this.onAppleTokenChanged.bind(this)}
              onGoogleTokenChanged={this.onGoogleTokenChanged.bind(this)}
              onSubmit={this.onSubmit.bind(this)}
              isEnhancedFormEnabled={isEnhancedFormEnabled}
              phoneState={this.state.phone}
            />
          );
        case APPLE_LOGIN_FORM_VIEW:
          return (
            <AppleLoginForm
              error={error}
              submitting={submitting}
              onAppleTokenChanged={this.onAppleTokenChanged.bind(this)}
            />
          );
        case GOOGLE_LOGIN_FORM_VIEW:
          return (
            <GoogleLoginForm
              error={error}
              submitting={submitting}
              onGoogleTokenChanged={this.onGoogleTokenChanged.bind(this)}
            />
          );
        case EMAIL_LOGIN_FORM_VIEW:
          return (
            <EmailLoginForm
              error={error}
              submitting={submitting}
              onEmailChange={this.onEmailChange.bind(this)}
              onSubmit={this.onSubmit.bind(this)}
            />
          );
        case OTP_VIEW:
          return (
            <OtpView
              identifier={this.getIdentifier()}
              clientId={this.state.clientId}
              onOtpVerify={this.onOtpVerify.bind(this)}
              submitError={error}
              invoiceId={this.state.invoiceId}
              isEnhancedFormEnabled={isEnhancedFormEnabled}
              onClickBack={this.redirectToLoginHandler.bind(this)}
            />
          );
        case PASSWORD_FORM_VIEW:
          return (
            <PasswordLoginForm
              isTryAnotherWayVisible={
                this.state.challenge.isTryAnotherWayVisible
              }
              error={error}
              submitting={submitting}
              signupEndpoint={this.constructSignupEndpoint()}
              recoveryEndpoint={this.constructRecoveryEndpointEndpoint()}
              onPasswordChange={this.onPasswordChange.bind(this)}
              onTryAnotherClickHandler={this.onTryAnotherClickHandler.bind(
                this
              )}
              onSubmit={this.onSubmit.bind(this)}
              fullPhoneNumber={this.state.phone?.fullPhoneNumber}
            />
          );
        case NAME_CONFIRMATION:
          return (
            <NameConfirmationLoginForm
              error={error}
              submitting={submitting}
              name={this.state.name}
              onNameConfirmed={this.onNameConfirmed.bind(this)}
              onSubmit={this.onSubmit.bind(this)}
              recoveryEndpoint={this.constructRecoveryEndpointEndpoint()}
              onPasswordChange={this.onPasswordChange.bind(this)}
            />
          );
        case REDIRECT_TO_IDP:
          return isEnhancedFormEnabled ? (
            <RedirectToLoginEnhanced
              fieldName={this.state.redirectToIdpParams.fieldName}
              value={this.state.redirectToIdpParams.value}
              clientId={this.state.redirectToIdpParams.clientId}
              csrf={this.state.csrf}
              isRegistration={false} // TODO figure out flow
            />
          ) : (
            <RedirectToLogin
              fieldName={this.state.redirectToIdpParams.fieldName}
              value={this.state.redirectToIdpParams.value}
              clientId={this.state.redirectToIdpParams.clientId}
              csrf={this.state.csrf}
            />
          );
        case REDIRECT_TO_SIGNUP:
          return <Redirect to={this.constructSignupEndpoint()} />;
        case REDIRECT_TO_BLOCKED_USER:
          return (
            <BlockedUser
              blockedErrorState={this.state.blockedErrorState}
              blockedErrorMsg={this.state.blockedErrorMsg}
              fullPhoneNumber={this.getIdentifier()}
              redirectToLoginHandler={this.redirectToLoginHandler.bind(this)}
            />
          );
        case VERIFY_CARD_FORM_VIEW:
          return (
            <VerifyCardLoginForm
              isTryAnotherWayVisible={
                this.state.challenge.isTryAnotherWayVisible
              }
              onCardPinChange={this.onCardPinChange.bind(this)}
              onTryAnotherClickHandler={this.onTryAnotherClickHandler.bind(
                this
              )}
              onSubmit={this.onSubmit.bind(this)}
              createAccount={this.createAccount.bind(this)}
              fullPhoneNumber={this.fullPhoneNumber}
              error={error}
              submitting={this.submitting}
            />
          );
        case VERIFY_EMAIL_FORM_VIEW:
          return (
            <VerifyEmailLoginForm
              isTryAnotherWayVisible={
                this.state.challenge.isTryAnotherWayVisible
              }
              onEmailChange={this.onEmailChange.bind(this)}
              onTryAnotherClickHandler={this.onTryAnotherClickHandler.bind(
                this
              )}
              onSubmit={this.onSubmit.bind(this)}
              maskedValue={this.state.challenge.masked_value}
              createAccount={this.createAccount.bind(this)}
              fullPhoneNumber={this.fullPhoneNumber}
              error={error}
              submitting={this.submitting}
            />
          );
        case VERIFY_FULL_NAME_FORM_VIEW:
          return (
            <VerifyNameLoginForm
              isTryAnotherWayVisible={
                this.state.challenge.isTryAnotherWayVisible
              }
              onFullNameChange={this.onFullNameChange.bind(this)}
              onTryAnotherClickHandler={this.onTryAnotherClickHandler.bind(
                this
              )}
              onSubmit={this.onSubmit.bind(this)}
              maskedValue={this.state.challenge.masked_value}
              createAccount={this.createAccount.bind(this)}
              fullPhoneNumber={this.fullPhoneNumber}
              error={error}
              submitting={this.submitting}
            />
          );
        case VERIFY_PIN_FORM_VIEW:
          return (
            <VerifyPinLoginForm
              isTryAnotherWayVisible={
                this.state.challenge.isTryAnotherWayVisible
              }
              onPinChange={this.onPinChange.bind(this)}
              onTryAnotherClickHandler={this.onTryAnotherClickHandler.bind(
                this
              )}
              onSubmit={this.onSubmit.bind(this)}
              createAccount={this.createAccount.bind(this)}
              fullPhoneNumber={this.fullPhoneNumber}
              error={error}
              submitting={this.submitting}
            />
          );
        case DASHBOARD_SELECTION_VIEW:
          return <DashboardSelectionPage currentUrl={window.location.href} />;
        case INSTANT_CREDENTIALS_FORM_VIEW:
          return (
            <InstantCredentialsForm
              error={error}
              submitting={submitting}
              onInstantCredentialsUserIdChange={this.onInstantCredentialsUserIdChange.bind(
                this
              )}
              onPasswordChange={this.onPasswordChange.bind(this)}
              onSubmit={this.onSubmit.bind(this)}
            />
          );
        case MERCHANT_SIGNUP_FORM_VIEW:
          return (
            <MerchantSignupForm
              error={error}
              submitting={submitting}
              email={this.state.email || ""}
              fullName={this.state.merchantFullName}
              password={this.state.password}
              onFullNameChange={this.onMerchantFullNameChange.bind(this)}
              onPasswordChange={this.onPasswordChange.bind(this)}
              onSubmit={this.onMerchantSignupSubmit.bind(this)}
            />
          );
        default:
          break;
      }
    };

    return renderMainContent();
  }

  getIdentifier() {
    return this.state.email ?? this.state.phone.fullPhoneNumber;
  }
}

Login.propTypes = {
  t: Types.func,
  history: Types.object.isRequired,
  location: Types.object,
};
